interface PrivateRumView {
  view: { url: string; name?: string; referrer?: string };
  context?: Record<string, unknown>;
}

export function redactPrivateRumView(event: PrivateRumView): void {
  event.view.url = "https://goldfinch.com/private-application";
  event.view.name = "Private application";
  event.view.referrer = "";
  event.context = {};
}

export function redactPrivateReferrer(
  event: PrivateRumView,
  isPrivateUrl: (url: string) => boolean,
): void {
  if (event.view.referrer != null && isPrivateUrl(event.view.referrer)) {
    event.view.referrer = "";
  }
}
